import { CustomChartBuilder } from '@carboncopyco/editor-ui';
import { memo } from 'react';
import { useEditorCharts } from '../context/EditorSdkProvider';
import { useEditorTool } from '../hooks/useEditorTool';

export const CustomChartBuilderTool = memo(() => {
  const {
    chartTemplates,
    fetchChartTemplates,
    createChartTemplate,
    updateChartTemplate,
    deleteChartTemplate,
  } = useEditorCharts();
  const { isOpen, close } = useEditorTool('customCharts');
  return isOpen ? (
    <CustomChartBuilder
      chartTemplates={chartTemplates}
      fetchChartTemplates={fetchChartTemplates}
      createChartTemplate={createChartTemplate}
      updateChartTemplate={updateChartTemplate}
      deleteChartTemplate={deleteChartTemplate}
      onClose={close}
    />
  ) : null;
});

CustomChartBuilderTool.displayName = 'CustomChartBuilderTool';
